var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { BaseDropTarget } from './base-drop-target';
import { DriveState } from '../../state/drive-state';
import { Store } from '@ngxs/store';
import { MoveEntries } from '../../state/actions/commands';
var FolderDropTargetDirective = /** @class */ (function (_super) {
    __extends(FolderDropTargetDirective, _super);
    function FolderDropTargetDirective(el, store) {
        var _this = _super.call(this) || this;
        _this.el = el;
        _this.store = store;
        return _this;
    }
    FolderDropTargetDirective.prototype.canDrop = function () {
        var entries = this.store.selectSnapshot(DriveState.selectedEntries), folder = this.folder;
        return DriveState.canMoveEntriesTo(entries, folder);
    };
    FolderDropTargetDirective.prototype.executeAction = function () {
        return this.store.dispatch(new MoveEntries(this.folder));
    };
    return FolderDropTargetDirective;
}(BaseDropTarget));
export { FolderDropTargetDirective };
